import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import Confirm from 'wix-ui-icons-common/Confirm';
import FormFieldErrorSmall from 'wix-ui-icons-common/system/FormFieldErrorSmall';
import StatusAlertFilled from 'wix-ui-icons-common/StatusAlertFilled';
import { Type, StepType } from '../constants';
import styles from './StepMarker.st.css';

var StepMarker = function StepMarker(_ref) {
  var number = _ref.number,
      active = _ref.active,
      type = _ref.type,
      styleType = _ref.styleType,
      hovered = _ref.hovered,
      disabled = _ref.disabled,
      otherProps = _objectWithoutProperties(_ref, ["number", "active", "type", "styleType", "hovered", "disabled"]);

  var renderCompleted = function renderCompleted() {
    return /*#__PURE__*/React.createElement(Confirm, null);
  };

  var renderNumber = function renderNumber() {
    return "".concat(number).concat(styleType === Type.Text ? '.' : '');
  };

  var renderError = function renderError() {
    return styleType === Type.Text ? /*#__PURE__*/React.createElement(StatusAlertFilled, null) : /*#__PURE__*/React.createElement(FormFieldErrorSmall, {
      size: "12px"
    });
  };

  return /*#__PURE__*/React.createElement("div", styles('root', {
    type: type,
    styleType: styleType,
    selected: active,
    hovered: hovered
  }, otherProps), type === StepType.Error ? renderError() : type === StepType.Completed ? renderCompleted() : renderNumber());
};

export default StepMarker;